import { createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "revico-community-talk-talkroom-details" }
const _hoisted_2 = { class: "revico-community-talk-talkroom-details-contents" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 閉じる ")
const _hoisted_4 = { class: "revico-community-talk-talkroom-details-no-reply" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["CommunityTalkUser"], {
        "view-model": $setup.communityTalkUserViewModel,
        "post-date": $props.talkRoom.talkRoomDate,
        "new-arrival-badge-display-days": $setup.communityTalkStore.getGeneralSettings().newArrivalBadgeDisplayDays,
        "new-arrival-badge-text": $setup.communityTalkStore.getWordSettings().newArrivalBadgeText
      }, null, 8 /* PROPS */, ["post-date", "new-arrival-badge-display-days", "new-arrival-badge-text"]),
      _createVNode($setup["TalkRoomContents"], {
        contents: $props.talkRoom.contents
      }, null, 8 /* PROPS */, ["contents"]),
      _createVNode($setup["CommunityTalkMedia"], {
        images: $setup.props.talkRoom.images,
        movies: $setup.props.talkRoom.movies
      }, null, 8 /* PROPS */, ["images", "movies"]),
      _createVNode($setup["TalkRoomNice"], {
        niceCount: $props.talkRoom.goodCount,
        communityTalkStoreKey: $props.communityTalkStoreKey,
        talkRoomId: $props.talkRoom.talkRoomId
      }, null, 8 /* PROPS */, ["niceCount", "communityTalkStoreKey", "talkRoomId"]),
      _createVNode($setup["TalkRoomDate"], {
        talkRoomDate: $props.talkRoom.talkRoomDate
      }, null, 8 /* PROPS */, ["talkRoomDate"])
    ]),
    _createCommentVNode(" リプライが1件でもある場合 "),
    ($setup.props.talkRoom.replyCount !== 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createCommentVNode(" 概要表示時 "),
          (!$setup.isDetailsMode())
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createCommentVNode(" ベストアンサー "),
                ($props.talkRoom.bestAnswerReply)
                  ? (_openBlock(), _createBlock($setup["ReplyMaster"], {
                      key: 0,
                      reply: $props.talkRoom.bestAnswerReply,
                      wordSettings: $props.wordSettings,
                      communityTalkStoreKey: $props.communityTalkStoreKey,
                      replyPostStoreKey: $setup.replyPostStoreKey
                    }, null, 8 /* PROPS */, ["reply", "wordSettings", "communityTalkStoreKey"]))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" リプライ総数(詳細表示ボタン) "),
                (!$setup.isDetailsMode() && $setup.props.talkRoom.replyCount > 1)
                  ? (_openBlock(), _createBlock($setup["ReplyOpenDetailsButton"], {
                      key: 1,
                      replyCount: $props.talkRoom.replyCount,
                      replyMoreDisplayText: $props.wordSettings.replyMoreDisplayText,
                      isProcessingGetMoreReply: $setup.isProcessingGetMoreReply(),
                      onOnClickMoreButton: $setup.getMoreReply
                    }, null, 8 /* PROPS */, ["replyCount", "replyMoreDisplayText", "isProcessingGetMoreReply"]))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" リプライ投稿フォーム "),
                _createCommentVNode(" ベストアンサー1件のみの表示の場合、投稿フォームがここに表示 "),
                _createVNode($setup["ReplyPost"], {
                  communityTalkStoreKey: $props.communityTalkStoreKey,
                  replyPostStoreKey: $setup.replyPostStoreKey,
                  wordSettings: $props.wordSettings
                }, null, 8 /* PROPS */, ["communityTalkStoreKey", "wordSettings"])
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createCommentVNode(" 詳細表示: リプライ追加表示 "),
                ($setup.isDetailsMode())
                  ? (_openBlock(), _createBlock($setup["ApiGetLoadWithAddMaster"], {
                      key: 0,
                      status: $setup.state.replyGetMoreStatus
                    }, {
                      contents: _withCtx(() => [
                        _createVNode($setup["ReplyList"], {
                          replies: $setup.replies,
                          wordSettings: $props.wordSettings,
                          communityTalkStoreKey: $props.communityTalkStoreKey,
                          replyPostStoreKey: $setup.replyPostStoreKey
                        }, null, 8 /* PROPS */, ["replies", "wordSettings", "communityTalkStoreKey"]),
                        _createCommentVNode(" リプライ追加表示ボタン "),
                        ($setup.isShowReplyMoreButton())
                          ? (_openBlock(), _createBlock($setup["ReplyMoreButton"], {
                              key: 0,
                              moreButtonDisplayName: $props.wordSettings.moreButtonDisplayName,
                              isProcessingGetMoreReply: $setup.isProcessingGetMoreReply(),
                              onOnClickMoreButton: $setup.getMoreReply
                            }, null, 8 /* PROPS */, ["moreButtonDisplayName", "isProcessingGetMoreReply"]))
                          : _createCommentVNode("v-if", true),
                        _createCommentVNode(" リプライ詳細表示閉じるボタン "),
                        _createElementVNode("button", {
                          type: "button",
                          class: "revico-community-talk-talkroom-details--details-close-button",
                          onClick: $setup.closeDetails
                        }, [
                          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-angle-down" }),
                          _hoisted_3
                        ]),
                        _createCommentVNode(" リプライ投稿フォーム "),
                        _createVNode($setup["ReplyPost"], {
                          communityTalkStoreKey: $props.communityTalkStoreKey,
                          replyPostStoreKey: $setup.replyPostStoreKey,
                          wordSettings: $props.wordSettings
                        }, null, 8 /* PROPS */, ["communityTalkStoreKey", "wordSettings"])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["status"]))
                  : _createCommentVNode("v-if", true)
              ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createCommentVNode(" リプライ0件時 "),
          _createElementVNode("div", _hoisted_4, [
            _createCommentVNode(" リプライが存在しない表示 "),
            _createVNode($setup["NoReply"], {
              noReplyText: $props.wordSettings.noReplyText
            }, null, 8 /* PROPS */, ["noReplyText"]),
            _createCommentVNode(" リプライ投稿フォーム "),
            _createVNode($setup["ReplyPost"], {
              communityTalkStoreKey: $props.communityTalkStoreKey,
              replyPostStoreKey: $setup.replyPostStoreKey,
              wordSettings: $props.wordSettings
            }, null, 8 /* PROPS */, ["communityTalkStoreKey", "wordSettings"])
          ])
        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
  ]))
}